import classes from './loop.module.css';
import StrokeTrace from './stroke-trace';

const STATIONS = [
    {
        n: '01',
        title: 'The student solves',
        body: "Pen on a tablet, exactly as they would work on paper — except every stroke is timestamped, every pause recorded, every erasure preserved, and the order the work was built up in is kept. The student feels nothing different. Nothing is worn, and nothing watches them.",
        accent: 'blue',
        trace: true,
    },
    {
        n: '02',
        title: 'The work becomes evidence',
        body: 'Strokes tie to questions; questions tie to topics. The record is a complete written solution, not a guess recovered from a multiple-choice answer.',
        accent: 'blue',
    },
    {
        n: '03',
        title: 'The graph makes sense of it',
        body: 'An educator-built map of more than 3,400 topics, with teacher-verified links between them. This is the layer that turns a Grade 10 quadratics mistake into "the missing piece is Grade 5 fraction division."',
        accent: 'teal',
    },
    {
        n: '04',
        title: 'The tutor walks in knowing',
        body: "No first twenty minutes spent working out where the student is. Prep and marking are already handled, so the hour opens on the part that only a person can do — noticing, and motivating.",
        accent: 'gold',
    },
    {
        n: '05',
        title: 'The parent sees the map',
        body: 'Not only a mark. Which foundations look solid, which are still forming, and what deserves a closer look next — the same evidence, told plainly.',
        accent: 'teal',
    },
];

const Loop = () => {
    return (
        <section id="loop" className={classes.section} aria-labelledby="loop-title">
            <div className={classes.aura} aria-hidden="true" />

            <div className={classes.inner}>
                <div className={classes.head}>
                    <p className="eyebrow">How it works</p>
                    <h2 id="loop-title" className={classes.title}>
                        One loop, closed.
                    </h2>
                    <p className={classes.lede}>
                        A student's real written work becomes the thing that decides what
                        their teacher does next — and what their parent gets to see. Our
                        three products are the three faces of that loop.
                    </p>
                </div>

                <ol className={classes.stations}>
                    {STATIONS.map((s) => (
                        <li key={s.n} className={classes.station}>
                            <div className={classes.rail} aria-hidden="true">
                                <span
                                    className={`${classes.node} ${classes[s.accent]}`}
                                />
                            </div>

                            <div className={classes.content}>
                                <span className={classes.n} aria-hidden="true">
                                    {s.n}
                                </span>
                                <h3 className={classes.stationTitle}>{s.title}</h3>
                                <p className={classes.stationBody}>{s.body}</p>

                                {s.trace && (
                                    <figure className={classes.traceFigure}>
                                        <StrokeTrace />
                                    </figure>
                                )}
                            </div>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
};

export default Loop;
